





















import { MarketingBannerConfig } from "@/model/marketing-banner-config";
import Vue from "vue";

export default Vue.extend({
	name: "MarketingBanner",
	data() {
		return <{ isPublished: boolean, isNotExpired: boolean, wrapClass: string, contentClass: string }>{
			isPublished: false,
			isNotExpired: false,
			wrapClass: "",
			contentClass: ""
		};
	},
	props: {
		bannerInfo: {
			type: Object as () => MarketingBannerConfig
		},
		viewType: {
			type: String,
			default: "marketing-banner"
		},
		showBanner: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		show(): boolean {
			return this.isPublished && this.isNotExpired && this.showBanner;
		},
		hasBanner(): boolean {
			return this.show === true || this.$slots.fallbackbanner != null;
		}
	},
	mounted: function () {
		const today = new Date();
		this.isPublished = today >= this.bannerInfo.publicationDate;
		this.isNotExpired = today <= this.bannerInfo.expirationDate;

		this.wrapClass = this.viewType + "__wrap";
		this.contentClass = this.wrapClass + "__content";
	}
});
